
































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop, Ref } from "vue-property-decorator";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import FormDescription from "@/components/misc/FormDescription.vue";
import { Action, Getter } from "vuex-class";
import {
  CalculationMethods,
  PriceCalculationMethodView,
} from "@/shared/models/priceCalculationMethods";
import { TaxRateView } from "@/shared/models/taxRates";
import * as _ from "lodash";
import { Currency } from "@/shared/models/currency";
import CurrencyDisplay from "@/components/misc/CurrencyDisplay.vue";
import {
  AddOnServiceModel,
  AddOnServicesSeasonPrice,
  AddOnServiceTranslation,
} from "@/shared/models/addOnService";
import { PropertyWithPostalCode } from "@/shared/models/property";
import { LanguageView } from "@/shared/models/languages";
import { ListModel } from "@/shared/models/listModel";
import { UnitOfMeasureView } from "@/shared/models/unitOfMeasure";
import NoData from "@/components/misc/NoData.vue";
import { PriceCalculationMethodsEnum, TenantTypesEnum, UnitsOfMesureEnum } from "@/shared/models/enums.type";
import DateField from "@/components/misc/DateField.vue";
import NumericInputImproved from "./numbers/NumericInputImproved.vue";
import { round } from "@/components/numbers/numberFormatUtils";
import { FinancialSettingsType } from "@/store/modules/financial";

@Component({
  components: {
    RightDrawer,
    FormDescription,
    NoData,
    NumericInputImproved,
    DateField,
    CurrencyDisplay,
  },
})
export default class AddOnServicesAndFeesForm extends Vue {
  @Prop({ default: null }) addOnServiceId!: number | null;
  @Prop({ default: null }) propertyId?: number | null;
  @Prop({ default: null }) accUnitId?: number | null;
  @Prop({ default: false }) open!: boolean;
  @Prop() callback!: () => any;

  descriptionTextResource = "AddOnService.FormInstructions";

  tab = 0;

  fkey = 0;

  loading = false;
  saving = false;
  initialService = new AddOnServiceModel();
  service = new AddOnServiceModel();

  @Watch("open")
  async openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.fkey++;
      this.tab = 0;
    }

    if (fresh && this.addOnServiceId) {
      await this.loadService();
      this.initialService = new AddOnServiceModel();
    } else {
      this.selected = [];
      this.service = new AddOnServiceModel();
      this.service.currencyId = this.workingCurrency?.id ?? 0;
      this.initialService = _.cloneDeep(this.service);

      this.nameFilter = "";
      this.addressFilter = "";
      this.postalCodeFilter = "";
    }
  }

  @Getter("appParams/tenantPaysVat") tenantPaysVat?: boolean;

  // prettier-ignore
  @Action("codebooks/refreshPriceCalculationMethods") refreshPriceCalculationMethods?: () => Promise<void>;
  // prettier-ignore
  @Getter("codebooks/priceCalculationMethods") priceCalculationMethods?: PriceCalculationMethodView[];
  // prettier-ignore
  @Action("codebooks/refreshTaxRates")refreshTaxRates?: () => Promise<void>;
  @Getter("codebooks/taxRates") taxRates?: TaxRateView[];
  // prettier-ignore
  @Action("codebooks/refreshCurrencies") refreshCurrencies?: () => Promise<void>;
  @Getter("codebooks/currencies") currencies?: Currency[];
  @Getter("appParams/workingCurrency") workingCurrency?: Currency;
  @Getter("appParams/formalCurrency") formalCurrency?: Currency;

  @Getter("appParams/typeId") tenantTypeId?: number;
  @Getter("appParams/countryId") tenantcountryId?: number;

  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;

  get currencyItems() {
    return [
      {
        id: this.formalCurrency?.id,
        text: this.formalCurrency?.isoCode,
      },
      {
        id: this.workingCurrency?.id,
        text: this.workingCurrency?.isoCode,
      },
    ];
  }

  @Getter("appParams/addOnServiceCanBeRelative") addOnServiceCanBeRelative?: boolean;
  // prettier-ignore
  @Action("codebooks/refreshLanguages") refreshLanguages?: () => Promise<void>;
  @Getter("codebooks/languages") languages?: LanguageView[];

  @Getter("codebooks/unitsOfMeasure") unitsOfMeasure?: UnitOfMeasureView[];
  get unitsOfMeasureSelectable() {
    return this.unitsOfMeasure?.map((x) => ({
      id: x.id,
      text: this.$t(x.textResourceKey),
    }));
  }

  @Getter("language/language") language?: string;

  get internalLanguage() {
    return this.language ?? "hr-HR";
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      zeroOrPositive: (value: number) => {
        return value >= 0 || this.$t("Validation.MustBeZeroOrPositive");
      },
      positiveButNotRequired: (value: any) =>
        value === null ||
        value === undefined ||
        +value >= 0 ||
        this.$t("Validation.MustBeZeroOrPositive"),
      untilDateAfterFromDate: (dateFrom: Date, dateUntil: Date) =>
        !(dateFrom > dateUntil && dateFrom && dateUntil) ||
        this.$t("AddOnService.Validation.DateFromBeforeDateUntil"),
      fromDateBeforeUntilDate: (dateFrom: Date, dateUntil: Date) =>
        !(dateFrom > dateUntil && dateFrom && dateUntil) ||
        this.$t("AddOnService.Validation.DateUntilAfterDateFrom"),
    };
  }
  maxLength(max: number) {
    return (v: string) =>
      !v || v.length <= max
        ? true
        : this.$t("Validation.MaxLength", { count: max });
  }

  containsPerNightMethods(serviceCalculationMethodId: number) {
    const rangeCalculationMethods = [
      CalculationMethods.PerNight,
      CalculationMethods.PerPersonPerNight,
      CalculationMethods.PerChildPerNight,
      CalculationMethods.PerAdultPerNight,
    ];

    return rangeCalculationMethods.includes(serviceCalculationMethodId);
  }

  validateDates() {
    const sorted = _.cloneDeep(this.service);

    sorted.seasonPrices.sort((a, b) => (a.dateFrom > b.dateFrom ? 1 : -1));

    for (let i = 1; i < sorted.seasonPrices.length; i++) {
      if (this.containsPerNightMethods(this.service.calculationMethodId)) {
        if (
          sorted.seasonPrices[i].dateFrom.substring(0, 10) <
          sorted.seasonPrices[i - 1].dateUntil.substring(0, 10)
        ) {
          return this.$t("AddOnServicesSeasonPrices.OverlappingDates");
        }
      } else {
        if (
          sorted.seasonPrices[i].dateFrom.substring(0, 10) <=
          sorted.seasonPrices[i - 1].dateUntil.substring(0, 10)
        ) {
          return this.$t("AddOnServicesSeasonPrices.OverlappingDates");
        }
      }
    }
    return true;
  }

  async created() {
    if (
      (this.priceCalculationMethods?.length ?? 0) === 0 &&
      this.refreshPriceCalculationMethods
    ) {
      await this.refreshPriceCalculationMethods();
    }
    if (!this.storedSettings && this.refreshSettings) {
      await this.refreshSettings();
    }
    if ((this.taxRates?.length ?? 0) === 0 && this.refreshTaxRates) {
      await this.refreshTaxRates();
    }
    if ((this.languages?.length ?? 0) === 0 && this.refreshLanguages) {
      await this.refreshLanguages();
    }
    if ((this.currencies?.length ?? 0) === 0 && this.refreshCurrencies) {
      await this.refreshCurrencies();
    }

    this.loadProperties();
  }

  isCityTaxChanged() {
    if (this.service.isCityTax && this.formalCurrency && this.storedSettings) {
      this.service.currencyId = this.formalCurrency.id;
      this.service.taxRateId = this.storedSettings.outOfScopeTaxRate.id ?? this.taxRates?.filter(x => x.isOutOfScope).map(e => e.id)[0];
    }
    if (!this.service.isCityTax && this.workingCurrency) {
      this.service.currencyId = this.workingCurrency.id;
    }
    if (this.service.isCityTax) {
      this.service.isFoodAndBeverages = false;
      this.service.consumptionTaxRate = null;
      this.service.pricesAreSeasonal = false;
      this.service.seasonPrices = [];
    }
  }

  isRelativeChanged() {
    if (this.service.isRelative) {
      this.service.unitOfMeasureId = UnitsOfMesureEnum.Usluga;
      this.service.calculationMethodId = PriceCalculationMethodsEnum.PerStay;
      this.service.consumptionTaxRate = null;
      this.service.pricesAreSeasonal = false;
      this.service.isFoodAndBeverages = false;
    }
  }

  get AOSTaxRatesForExemption() {
    return this.taxRates?.filter(x => x.rate === 0).map(e => e.id) ?? [];
  }

  get showTaxExemptionReason() {
    return this.AOSTaxRatesForExemption.includes(this.service.taxRateId) && this.tenantPaysVat;
  }

  loadingProperties = true;
  properties: PropertyWithPostalCode[] = [];
  loadProperties() {
    this.loadingProperties = true;
    Vue.axios
      .get<ListModel<PropertyWithPostalCode>>(
        "/properties/PropertiesWithPostalCode",
        {
          params: {
            $count: true,
            $skip: this.properties.length,
            $orderby: "propertyId",
          },
        }
      )
      .then((res) => {
        this.properties.push(...res.data.result);
        if (res.data.count && this.properties.length < res.data.count) {
          this.loadProperties();
        }
      })
      .finally(() => (this.loadingProperties = false));
  }

  isFormValid = false;
  get submitDisabled(): boolean {
    return this.isFormValid && !this.loading;
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & {
      validate: () => boolean;
    };
  }

  @Ref("drawer") rightDrawer?: RightDrawer;

  close() {
    this.rightDrawer?.clickOverlay();
  }

  loadService() {
    this.loading = true;
    Vue.axios
      .get<AddOnServiceModel>("/AddOnServices/" + this.addOnServiceId)
      .then((res) => {
        this.service = res.data;

        this.selected =
          this.properties?.filter((x) =>
            this.service.propertiesIds.some((e) => e == x.propertyId)
          ) || [];
        this.initialService = _.cloneDeep(this.service);
        this.loading = false;
      });
  }

  async submit() {
    this.form.validate();

    if (!this.isFormValid) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("Changes are invalid or incomplete"),
        timeout: 5000,
      });

      return;
    }

    if (this.checkForDuplicateTranslations()) {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("AddOnService.DuplicateTranslations"),
        timeout: 5000,
      });

      return;
    }

    //submit
    this.saving = true;
    if (this.service.id && this.service.id !== 0) {
      await Vue.axios
        .put("/AddOnServices/" + this.service.id, this.service)
        .then(() => {
          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("AddOnService.SaveSuccess"),
            timeout: 5000,
          });

          this.$emit("update:open", false);
          this.callback();
        })
        .finally(() => {
          this.saving = false;
        });
    } else {
      if (this.propertyId) {
        this.service.propertiesIds.push(this.propertyId);
      }
      if (this.accUnitId) {
        this.service.accUnitId = this.accUnitId;
      }
      await Vue.axios
        .post("/AddOnServices", this.service)
        .then((res) => {
          this.service = {
            ...this.service,
            id: res.data,
          };

          this.initialService = _.cloneDeep(this.service);

          this.$store.dispatch("showNotification", {
            color: "success",
            message: this.$t("AddOnService.SaveSuccess"),
            timeout: 5000,
          });
          //from property/accUnitType - close all modals and reload
          if (this.propertyId || this.accUnitId) {
            this.$emit("serviceAdded");
          }
          this.$emit("update:open", false);
          this.callback();
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  getNetPriceWithConsumptionTax(grossPrice: number) {
    const taxRateFactor =
      (this.taxRates?.find((e) => e.id === this.service.taxRateId)?.rate ?? 0) /
      100;
    const conTaxFactor = (this.service.consumptionTaxRate ?? 0) / 100;
    const netPrice = grossPrice / (1 + taxRateFactor + conTaxFactor);
    return round(netPrice, 2);
  }

  isFoodAndBeveragesChanged() {
    if (!this.service.isFoodAndBeverages) {
      this.service.consumptionTaxRate = null;
    }
    if (this.service.isFoodAndBeverages) {
      this.service.isCityTax = false;
      this.service.isRelative = false;
    }
  }

  addTranslation() {
    this.service.translations.push({
      id: 0,
      addOnServiceId: 0,
      cultureCode: "",
      translation: "",
    });
  }

  removeTranslation(translation: AddOnServiceTranslation) {
    const index = this.service.translations.findIndex((x) => x == translation);
    if (index != -1) {
      this.service.translations.splice(index, 1);
    }
  }

  checkForDuplicateTranslations() {
    const duplicatesArray: string[] = [];
    this.service.translations.forEach((x) =>
      duplicatesArray.push(x.cultureCode)
    );
    duplicatesArray.sort();
    for (let i = 0; i < duplicatesArray.length - 1; i++) {
      if (duplicatesArray[i + 1] == duplicatesArray[i]) {
        return true;
      }
    }
    return false;
  }

  addSeasonPrice() {
    this.service.seasonPrices.push({
      id: 0,
      addOnServiceId: 0,
      netPrice: 0,
      grossPrice: 0,
      dateFrom: "",
      dateUntil: "",
      ownerPayoutAmountSeason: this.service.ownerPayoutAmount ?? 0,
      ownerPayoutIsAbsoluteSeason: false,
    });
  }

  removeSeasonPrice(seasonPrice: AddOnServicesSeasonPrice) {
    const index = this.service.seasonPrices.findIndex((x) => x == seasonPrice);
    if (index != -1) {
      this.service.seasonPrices.splice(index, 1);
    }
  }

  headers = [
    {
      text: "Property",
      value: "name",
    },
    {
      text: "Address",
      value: "address",
    },
    {
      text: "City",
      value: "postalCodeAndCity",
    },
  ];

  get translatedHeaders() {
    return this.headers.map((x) => ({ ...x, text: this.$t(x.text) }));
  }

  selected = [] as PropertyWithPostalCode[];

  nameFilter = "";
  addressFilter = "";
  postalCodeFilter = "";

  get filteredProperties() {
    if (!this.properties) {
      return [];
    }

    return this.properties
      .filter(
        (e) =>
          !this.nameFilter ||
          e.name.toLowerCase().includes(this.nameFilter.toLowerCase())
      )
      .filter(
        (e) =>
          !this.addressFilter ||
          e.address.toLowerCase().includes(this.addressFilter.toLowerCase())
      )
      .filter(
        (e) =>
          !this.postalCodeFilter ||
          e.postalCodeAndCity
            .toLowerCase()
            .includes(this.postalCodeFilter.toLowerCase())
      );
  }

  areAllPropertiesSelected() {
    return !this.properties?.some(
      (e) =>
        this.service.propertiesIds.findIndex((acc) => acc == e.propertyId) == -1
    );
  }

  selectProperty({
    item,
    value,
  }: {
    item: PropertyWithPostalCode;
    value: boolean;
  }) {
    if (
      value &&
      !this.service.propertiesIds.some((x) => x == item.propertyId)
    ) {
      this.service.propertiesIds.push(item.propertyId);
    } else if (!value) {
      const index = this.service.propertiesIds.findIndex(
        (x) => x == item.propertyId
      );
      if (index != -1) {
        this.service.propertiesIds.splice(index, 1);
      }
    }
  }

  selectAllProperties(value: boolean) {
    if (!this.properties) {
      return;
    }

    if (value) {
      for (const prop of this.properties) {
        if (!this.service.propertiesIds.some((x) => x == prop.propertyId)) {
          this.service.propertiesIds.push(prop.propertyId);
          this.selected.push(prop);
        }
      }
    } else {
      for (const prop of this.properties) {
        const index = this.service.propertiesIds.findIndex(
          (x) => x == prop.propertyId
        );

        if (index != -1) {
          this.service.propertiesIds.splice(index, 1);
        }

        const selectedIndex = this.selected.findIndex(
          (x) => x.propertyId == prop.propertyId
        );
        if (selectedIndex != -1) {
          this.selected.splice(selectedIndex, 1);
        }
      }
    }
  }
  get isTenantAnAgency() {
    return this.tenantTypeId == TenantTypesEnum.Agency;
  }
}
